'use client';

import React from 'react';
import SupplierContactForm from '@/app/components/suppliers/SupplierContactForm';
import Scribble from '@/app/components/suppliers/Scribble';

export default function SupplierContactSection({ id }: { id: string }) {
  return (
    <section id={ id } className='container mt-24 md:mt-40 scroll-mt-32'>
      <div className='grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-start'>
        <div className='lg:col-span-5'>
          <h2 className='sup-h2'>
            Co prodáváte?<br />Dejte vědět<br />
            <span className='relative inline-block'>a mrkneme
              <Scribble kind='underline' color='var(--sup-purple)' width={ 8 } style={ { left: '-2%', right: '-2%', bottom: '-0.1em', height: '0.3em' } } />
            </span> na to!
          </h2>
          <p className='sup-body mt-8'>
            Napíšeme si, co prodáváte a komu. Vrátíme vám návrh, jak to dostat před majitele podniků. Zdarma a bez závazků.
          </p>
          <ul className='mt-8 flex flex-col gap-3 sup-body'>
            <li className='flex gap-3 items-start'><span className='mt-[0.45em] w-3 h-3 rounded-full bg-heat inline-block flex-none' style={ { background: 'var(--sup-heat)' } } />Odpovídáme do 2 pracovních dnů.</li>
            <li className='flex gap-3 items-start'><span className='mt-[0.45em] w-3 h-3 rounded-full inline-block flex-none' style={ { background: 'var(--sup-purple)' } } />Návrh dostanete i s odhadem ceny za poptávku.</li>
          </ul>
        </div>
        <div className='lg:col-span-7 relative'>
          <Scribble kind='arrow' color='var(--sup-heat)' width={ 6 } className='hidden lg:block' style={ { left: '-120px', top: '-70px', width: '120px', height: '120px', transform: 'rotate(-35deg)' } } />
          <div className='sup-card p-6 md:p-10 bg-[var(--sup-sand)]'>
            <SupplierContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
